import {Component, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {MatTableDataSource} from '@angular/material/table';
import {DateRangeDto} from '../../shared/dto/DateRangeDto';
import {smsSearchDTO} from '../../shared/dto/smsSearchDTO';
import {SmsModel} from '../../model/smsModel';
import swal from 'sweetalert2';
import {SmsService} from '../../shared/service/sms.service';
import {CityDTO} from '../../shared/dto/city.model';


@Component({
  selector: 'app-sms-mgt',
  templateUrl: './sms-mgt.component.html',
  styleUrls: ['./sms-mgt.component.scss']
})
export class SmsMgtComponent implements OnInit {
  public requestForm:FormGroup;
  public dto: SmsModel[] = [];
  public smsConfigItem: SmsModel[] = [];


  constructor(private smsService: SmsService) { }


  ngOnInit() {
  this.requestForm = new FormGroup({
    dateTimeRange :new FormControl(null),
    mobileNo :new FormControl(null)
  });

  this.loadAllRecords();
  }

  onSubmitSearch(form: FormGroup) {
    const dateRange = new DateRangeDto();
    dateRange.date =(form.value.dateTimeRange);
    this.loadAllSearchResults(dateRange,form.controls["mobileNo"].value);
  }

  onClickReset() {
    this.requestForm.reset({
      dateTimeRange :[],
      mobileNo: null
      });
    this.loadAllRecords();
  }


  loadAllRecords() {
    this.smsService.getAllRecords().subscribe(
      (data: SmsModel[]) => {
        this.dto = data;
        this.smsConfigItem=data;

      });
  }


  loadAllSearchResults(date:DateRangeDto,mobileNo:string):void{
    const smsSearchParam = new smsSearchDTO();
    smsSearchParam.dateRangeDto = date;
    smsSearchParam.mobile = mobileNo;

    this.smsService.searchRequestDetails(smsSearchParam).subscribe(
      (data: SmsModel[]) => {
        this.smsConfigItem = data;
      },(error) => {
        swal.fire('Sorry', 'Please fill at least one field.','error');
      },

      () => {
        if (this.smsConfigItem == null || this.smsConfigItem.length === 0) {
          swal.fire('Sorry', 'No result found.', 'error');

        }
      });
  }

}



